import { useQuery } from '@tanstack/react-query';
import { fetchReplacementList } from "./endpoints";
export const useReplacementList = (agreementId, agreementDetailId) => {
    const { data: replacementList, isFetching, isLoading, error: replacementListError, } = useQuery({
        queryKey: ['replacementList', agreementId, agreementDetailId],
        queryFn: () => fetchReplacementList(agreementId, agreementDetailId),
        enabled: !!agreementId && !!agreementDetailId,
    });
    return {
        replacementList,
        isFetching,
        isLoading,
        replacementListError,
    };
};
